<template>
  <div class="divide-bg" :style="{height: height + 'px'}"></div>
</template>

<script>
export default {
  name: "gj-separator",
  props: {
    //分隔线高度
    height: {
      type: Number,
      default: 20
    },
    // 分隔线边距
    padding: {
      type: Array,
      default: () => [0,0,0,0]
    }
  }
}
</script>

<style scoped>
  .divide-bg{
    width: 100%;
    background: #f6f6f6;
  }
</style>